import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';
import { PolicyAttributesComponent } from '../../../policy-details/policy-attributes.component';

@Component({
  selector: 'app-endorsement',
  imports: [TableComponent, ColumnComponent, PolicyAttributesComponent],
  template: ` <app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    [expandable]="true"
    dataKey="id"
    [stripedRows]="false"
    recordLabel="Endorsement"
    [globalFilterFields]="[
      'documentId',
      'effectiveDate',
      'expireDate',
      'comment',
    ]"
  >
    <app-column name="documentId" label="Document ID" width="20%" />
    <app-column
      name="effectiveDate"
      label="Effective Date"
      format="d"
      width="15%"
    />
    <app-column name="expireDate" label="Expire Date" format="d" width="15%" />
    <app-column
      name="comment"
      label="Comment"
      [fullRow]="true"
      [fullRowLabel]="true"
    >
      <ng-template #item let-row>
        <span class="tw-text-wrap tw-leading-6">{{ row.comment }}</span>
      </ng-template>
    </app-column>
    <ng-template #expand let-data>
      <div class="tw-flex tw-gap-8 tw-pb-2">
        <div class="tw-basis-full">
          <app-policy-attributes
            [dataSource]="data.attributes"
            [showEmpty]="true"
            [source]="lineOfBusiness"
            layout="policy"
            theme="Dark"
          />
        </div>
      </div>
    </ng-template>
  </app-table>`,
  styles: [],
})
export class PolicyEndorsementComponent {
  @Input() dataSource: any;
  @Input() lineOfBusiness: string;
}
